export enum ProductType {
  voucher = 'Voucher',
  topUp = 'Topup',
  range = 'RangeProduct',
}
